import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Portals provide a first-class way to render children into a DOM node that exists outside the DOM hierarchy of the parent component.
 *
 * @see https://reactjs.org/docs/portals.html
 */
const Portal = _ref => {
  let {
    children,
    className,
    tag = "div",
    renderInContainer
  } = _ref;
  const [renderIn] = useState(() => {
    const el = document.createElement(tag);
    className && el.classList.add(className);
    return el;
  });

  // Append container to `body`
  useEffect(() => {
    document.body.appendChild(renderIn);
    return () => {
      document.body.removeChild(renderIn);
    };
  }, []);
  return /*#__PURE__*/createPortal(children, renderInContainer || renderIn);
};
export { Portal };